import { gql } from 'graphql-request';

//Sample movie query
export const FETCH_MUSIC_DATA_QUERY = gql`
  query ($filter: MovieFilter!) {
    movies(filter: $filter) {
      __typename
      id
      tags
      contents {
        ... on Movie {
          id
          title
          originalTitle
          description
          image {
            list
            cover
            listClean
            sticker
            svodCover
            appCover
            channelSquare
            channelList
            square
            portrait
            logo
            verticalBanner
            mobileBanner
            desktopBanner
          }
          shortDescription
          billingType
          businessType
          duration
          contentOwner
          genres {
            id
            value
          }
          languages
          assetType
          assetSubType
          releaseDate
          actors
          ageRating
          audioLanguages
          subtitleLanguages
          eventLive
          tags
          introStartTime
          introEndTime
          tier
          playDate
          seoTitle
          slug
          webUrl
          rating
          playedDuration
          video {
            url
            drmKey
            hlsUrl
            isDrm
          }
          relatedContentIds {
            id
          }
        }
      }
    }
  }
`;
